module.exports = "/remote-dist/f0ebd4d408481ee9ae41067696897057.png";